export function removeHtml(html: string) {
  let dom = new DOMParser().parseFromString(html, "text/html");
  return dom.body.textContent || "";
}
